import { Typography } from "@mui/material";
import React, { useState } from "react";
import "./conatinerWithTab.css";
const ContainerWithTab = ({ tabs, style, contentStyle, filters }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const conainterContentStyle = {
    ...contentStyle,
  };
  return (
    <div className="container-root" style={style}>
      <div className="container-header">
        <div className="conatiner-title">
          <Typography
            className="semiboldSixteen"
            sx={{ color: "#0A090B !important" }}
          >
            {tabs[selectedTab]?.header}
          </Typography>
          <Typography className="container-subheader">
            {tabs[selectedTab]?.subHeader}
          </Typography>
        </div>
        <div className="filters-and-tabs">
          {filters}

          {tabs?.length > 1 && (
            <div className="container-tabs">
              {tabs?.map((tab, i) => {
                return (
                  <div
                    key={tab?.tabTitle}
                    className={
                      selectedTab === i ? "active-tab" : "inActive-tab"
                    }
                    onClick={() => setSelectedTab(i)}
                  >
                    <Typography
                      className={
                        selectedTab === i
                          ? "active-tab-font"
                          : "inActive-tab-font"
                      }
                    >
                      {tab?.tabTitle}
                    </Typography>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <div className="conatiner-content" style={conainterContentStyle}>
        {tabs[selectedTab]?.content}
      </div>
    </div>
  );
};

export default ContainerWithTab;
